export enum RewardBannerButtonAction {
  Story = 'story',
  Chat = 'chat',
}

export enum RewardBannerPrizeType {
  Hearts = 'hearts',
  Sapphires = 'sapphires',
  None = '',
}

export interface RewardBannerPrize {
  prizeType: RewardBannerPrizeType;
  prizeValue: string;
}

export interface RewardBanner {
  id: number;
  promotionId: number;
  title: string;
  description: string;
  imageUrl: string;
  active: boolean;
  priority: number;
  startTime: string | null;
  endTime: string | null;
  label: string;
  prize: string | null;
  buttonText: string;
  buttonAction: RewardBannerButtonAction;
  buttonTarget: string;
  specialRequirements: string;
  createdAt: string;
  updatedAt: string;
}

export interface RewardBannerResponse {
  success: boolean;
  rewardBanner: RewardBanner | null;
}

export interface RewardBannerCoverFile {
  fileName: string;
  file: Blob;
}

export interface RewardBannerFormValues {
  id?: number;
  title: string;
  description: string;
  label: string;
  priority: number;
  buttonText: string;
  specialRequirements: string;
  buttonAction: RewardBannerButtonAction;
  buttonTarget: string;
  prize: RewardBannerPrize;
  active: boolean;
  imageUrl: string;
  newCoverImage?: RewardBannerCoverFile;
}
